import SEO from '@/components/base/SEO';

export default function CategoryPage() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <SEO title="分类浏览 - 番号大全" description="按类型、演员、厂牌、系列等维度浏览番号" />
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-2xl">
          <i className="ri-stack-line text-primary-500 text-2xl"></i>
        </div>
        <h2 className="font-heading text-xl font-semibold text-foreground-800 mb-2">分类浏览</h2>
        <p className="text-sm text-foreground-500">即将上线，敬请期待</p>
      </div>
    </div>
  );
}